import { Plan } from '../types.ts';

import {
	getContentfulProductCatalogClient,
	getContentfulContentClient,
} from './contentful-clients.ts';

export type PlansByProduct = Record<string, Plan[]>;

export async function getPricingCalculatorData(
	pricingTitleInternals: string[],
): Promise<PlansByProduct> {
	const contentClient = await getContentfulContentClient();
	const contentResult = (await contentClient.getEntries({
		content_type: 'pricing',
		'fields.pricingTitleInternal[in]': pricingTitleInternals,
		select: [
			'sys',
			'fields.comparePlans',
			'fields.pricingTitleInternal',
			'fields.compareFeaturesTitle',
		],
		include: 10,
	})) as unknown as ContentResult;

	const productCatalogClient = getContentfulProductCatalogClient();

	const productCatalogResults = await Promise.all(
		contentResult.items.map((item) => {
			const skus = item.fields.comparePlans.map((plan) => plan.fields.sku);
			return productCatalogClient.getCCPPricingData(skus);
		}),
	);

	const ccpPricingData = productCatalogResults.reduce((acc, result) => {
		return { ...acc, ...result };
	}, {});

	return pricingTitleInternals.reduce<PlansByProduct>((acc, pricingTitleInternal) => {
		const product = contentResult.items.find(
			(product) => product.fields.pricingTitleInternal === pricingTitleInternal,
		);

		const comparePlans = product?.fields.comparePlans;
		if (!comparePlans) {
			return acc;
		}

		acc[pricingTitleInternal] =
			comparePlans.map(
				(plan) =>
					({
						...plan,
						pricingPlan: ccpPricingData[plan.fields.sku],
					}) as Plan,
			) ?? [];

		return acc;
	}, {});
}

interface ContentResult {
	items: Array<{
		fields: {
			pricingTitleInternal: string;
			comparePlans: Plan[];
		};
	}>;
}
